import { hideElement, setElementHtml } from '../../../../helpers/generic-js/dom.js'
import htmlTemplateIndex from './index.html'

export function showConnectionSuccess (params) {
  console.log('showConnectionSuccess', params)

  const { containerElementId, newXeroConnection } = params

  if (!newXeroConnection) {
    hideElement(containerElementId)
    return
  }

  setElementHtml(containerElementId, htmlTemplateIndex)
}
